import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Layout } from 'antd';

import {
    getGoogleProcessingPath,
    getPasswordRecoveryPath,
    getResetPasswordPath,
    getSignInPath,
    getSignUpPath,
} from '@/shared/constants/router';
import { useDesktopMediaQuery } from '@/shared/lib/hooks';
import { FullLogo } from '@/shared/ui/logo';

import RecoveryPasswordPreview from '@/shared/assets/images/recovery-password-preview.png';
import SignInVideoPreview from '@/shared/assets/images/sign-in-preview.png';
import SignUpVideoPreview from '@/shared/assets/images/sign-up-preview.png';
import RecoveryPasswordVideo from '@/shared/assets/videos/recovery-password.mp4';
import SignInVideo from '@/shared/assets/videos/sign-in.mp4';
import SignUpVideo from '@/shared/assets/videos/sign-up.mp4';

import cls from './auth-sider.module.css';

interface AuthSiderProps {
    pathRoute: string;
}

export const AuthSider = memo((props: AuthSiderProps) => {
    const { pathRoute } = props;

    const { t } = useTranslation();
    const isDesktop = useDesktopMediaQuery();

    const videoContent = useMemo(() => {
        switch (true) {
            case pathRoute.includes(getSignInPath()):
                return (
                    <video
                        autoPlay
                        className={cls.video}
                        loop
                        muted
                        poster={SignInVideoPreview}
                        preload="none"
                        src={SignInVideo}
                    >
                        {t('videoTagError')}
                    </video>
                );
            case pathRoute.includes(getSignUpPath()):
                return (
                    <video
                        autoPlay
                        className={cls.video}
                        loop
                        muted
                        poster={SignUpVideoPreview}
                        preload="none"
                        src={SignUpVideo}
                    >
                        {t('videoTagError')}
                    </video>
                );
            case pathRoute.includes(getPasswordRecoveryPath()) ||
                pathRoute.includes(getResetPasswordPath()):
                return (
                    <video
                        autoPlay
                        className={cls.video}
                        loop
                        muted
                        poster={RecoveryPasswordPreview}
                        preload="none"
                        src={RecoveryPasswordVideo}
                    >
                        {t('videoTagError')}
                    </video>
                );
            default:
                return null;
        }
    }, [pathRoute, t]);

    if (!isDesktop || pathRoute === getGoogleProcessingPath()) {
        return null;
    }

    return (
        <Layout.Sider className={cls.root}>
            <div className={cls.logoContainer}>
                <FullLogo isAuth />
            </div>
            {videoContent}
        </Layout.Sider>
    );
});

AuthSider.displayName = 'AuthSider';
